"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[27779],{

/***/ 319326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCard = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F,
  `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
`
]);
const CardHeader = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardBody = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const CardFooter = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, { children, header, footer, className } = _b, props = __objRest(_b, ["children", "header", "footer", "className"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, __spreadValues({
    className: (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeCls */ .c8)("teko-card", className || ""),
    ref
  }, props), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, {
    className: "teko-card-header"
  }, header), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, {
    className: "teko-card-body"
  }, children), footer && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, {
    className: "teko-card-footer"
  }, footer));
});
Card.displayName = "Card";




/***/ }),

/***/ 295624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ShoppingCartAddColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShoppingCartAddColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 18 18", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_21440_17520)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M13.5 9C12.7098 9.00092 11.9333 8.7935 11.2488 8.39865C10.5643 8.0038 9.99604 7.43547 9.60123 6.75096C9.20642 6.06645 8.99904 5.28995 9.00001 4.49974C9.00098 3.70953 9.21026 2.93354 9.60675 2.25H3.1815L3.15 1.986C3.08537 1.43895 2.82229 0.934615 2.41064 0.568578C1.99899 0.202541 1.46736 0.000234627 0.9165 0L0.75 0C0.551088 0 0.360322 0.0790176 0.21967 0.21967C0.0790176 0.360322 0 0.551088 0 0.75C0 0.948912 0.0790176 1.13968 0.21967 1.28033C0.360322 1.42098 0.551088 1.5 0.75 1.5H0.9165C1.1002 1.50002 1.2775 1.56747 1.41478 1.68954C1.55206 1.81161 1.63976 1.97981 1.66125 2.16225L2.69325 10.9373C2.80039 11.8498 3.23886 12.6913 3.92543 13.302C4.612 13.9127 5.49889 14.25 6.41775 14.25H14.25C14.4489 14.25 14.6397 14.171 14.7803 14.0303C14.921 13.8897 15 13.6989 15 13.5C15 13.3011 14.921 13.1103 14.7803 12.9697C14.6397 12.829 14.4489 12.75 14.25 12.75H6.41775C5.95341 12.7488 5.5008 12.6041 5.12201 12.3355C4.74321 12.067 4.45678 11.6878 4.302 11.25H13.2427C14.122 11.2501 14.9733 10.9412 15.6479 10.3773C16.3225 9.81348 16.7775 9.03052 16.9335 8.16525L17.112 7.176C16.6948 7.74162 16.1506 8.20136 15.5232 8.51817C14.8959 8.83499 14.2028 9.00003 13.5 9V9Z",
              fill: "#1435C3"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5.25 18.0005C6.07842 18.0005 6.74999 17.3289 6.74999 16.5005C6.74999 15.6721 6.07842 15.0005 5.25 15.0005C4.42157 15.0005 3.75 15.6721 3.75 16.5005C3.75 17.3289 4.42157 18.0005 5.25 18.0005Z",
              fill: "#1435C3"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M12.75 18.0005C13.5784 18.0005 14.25 17.3289 14.25 16.5005C14.25 15.6721 13.5784 15.0005 12.75 15.0005C11.9216 15.0005 11.25 15.6721 11.25 16.5005C11.25 17.3289 11.9216 18.0005 12.75 18.0005Z",
              fill: "#1435C3"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M11.25 5.25049H12.75V6.75049C12.75 6.9494 12.829 7.14017 12.9697 7.28082C13.1103 7.42147 13.3011 7.50049 13.5 7.50049C13.6989 7.50049 13.8897 7.42147 14.0303 7.28082C14.171 7.14017 14.25 6.9494 14.25 6.75049V5.25049H15.75C15.9489 5.25049 16.1397 5.17147 16.2803 5.03082C16.421 4.89017 16.5 4.6994 16.5 4.50049C16.5 4.30158 16.421 4.11081 16.2803 3.97016C16.1397 3.82951 15.9489 3.75049 15.75 3.75049H14.25V2.25049C14.25 2.05158 14.171 1.86081 14.0303 1.72016C13.8897 1.57951 13.6989 1.50049 13.5 1.50049C13.3011 1.50049 13.1103 1.57951 12.9697 1.72016C12.829 1.86081 12.75 2.05158 12.75 2.25049V3.75049H11.25C11.0511 3.75049 10.8603 3.82951 10.7197 3.97016C10.579 4.11081 10.5 4.30158 10.5 4.50049C10.5 4.6994 10.579 4.89017 10.7197 5.03082C10.8603 5.17147 11.0511 5.25049 11.25 5.25049V5.25049Z",
              fill: "#1435C3"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_21440_17520" },
            child: [
              {
                tag: "rect",
                attr: { width: "18", height: "18", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 232757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ BottomActionBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(916476);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(295624);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(500689);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(891256);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(309110);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(280392);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(212951);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(54230);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(141873);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(446586);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(428247);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(316035);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(534090);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(353632);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(634655);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(481633);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  .out-of-stock-button {\n    background-color: #dcdee9;\n    .button-text {\n      color: #a7abc3;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  height: 48px;\n  .button-text {\n    text-transform: uppercase;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 24px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  .quantity-selector {\n    width: 132px !important;\n    height: 40px !important;\n    .rc-input-number-input {\n      border-left: 1px solid ",
        ";\n      border-right: 1px solid ",
        ";\n      background-color: white;\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 24px;\n      white-space: nowrap;\n    }\n    border: 1px solid rgb(228, 229, 240);\n  }\n  .plus-btn {\n    background-color: white;\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













const BottomActionBar = ()=>{
    var ref;
    const { product , price , isOutOfStock , actionReady , isAllowInstallmentPayment , isCanAddToCard , primitiveProduct , selectedPromotion , stockAvailable , selectedPromotionsNotApplyWithInstallment , showWarningPromotionWithInstallment , setShowWarningPromotionWithInstallment , minAmountByMonth , payloadAddToCart , setPayloadAddToCart ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useProductDetailState */ .W)();
    const { contactLink , allowBuyNow , isIdleCallbackTrackingAddToCart , isMobile , numberDisplayFormat ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    const showToast = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .useToast */ .p)();
    const { onAddSingleItem  } = (0,contexts__WEBPACK_IMPORTED_MODULE_8__/* .useCartV2 */ .T6)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const isValidPrice = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        if (!product) return false;
        if (price) return price.finalPrice >= 0;
    }, [
        product,
        price
    ]);
    const showContact = !isValidPrice || isOutOfStock || !(product === null || product === void 0 ? void 0 : (ref = product.status) === null || ref === void 0 ? void 0 : ref.sellable);
    const onAddItemToCart = async (product, selectedPromotionId, addToCartPrice, isolatedCartType)=>{
        var ref;
        if (!product) return;
        const trackAddToCartParams = {
            product: {
                sku: (product === null || product === void 0 ? void 0 : product.productInfo.sellerSku) || "",
                name: (product === null || product === void 0 ? void 0 : product.productInfo.name) || "",
                brand: product === null || product === void 0 ? void 0 : product.productInfo.brand,
                categories: product === null || product === void 0 ? void 0 : product.productInfo.categories,
                price: parseFloat(product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref[0].supplierRetailPrice),
                addToCartPrice: addToCartPrice,
                sellerSku: product === null || product === void 0 ? void 0 : product.productInfo.sellerSku
            },
            selectedPromotionId,
            type: isolatedCartType === _teko_cart_v2__WEBPACK_IMPORTED_MODULE_9__/* .IsolatedCartType.BUY_NOW */ .oG.BUY_NOW ? _teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.BUYNOW */ .h.BUYNOW : isolatedCartType === _teko_cart_v2__WEBPACK_IMPORTED_MODULE_9__/* .IsolatedCartType.INSTALLMENT */ .oG.INSTALLMENT ? _teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.INSTALLMENT */ .h.INSTALLMENT : _teko_tracking__WEBPACK_IMPORTED_MODULE_10__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART
        };
        if (!payloadAddToCart) return;
        try {
            const res = await onAddSingleItem({
                sku: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku,
                promotionId: selectedPromotionId,
                quantity: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity,
                isPrimary: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.isPrimary
            }, false, isolatedCartType);
            if (res) {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_11__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "success",
                    cartId: res.id
                }), isIdleCallbackTrackingAddToCart);
                if (!!isolatedCartType) {
                    const key = (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_9__/* .getBuyNowKey */ .B2)(true);
                    await router.push("/checkout?bnk=".concat(key));
                }
            } else {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_11__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "failed"
                }), isIdleCallbackTrackingAddToCart);
            }
        } catch (e) {
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_11__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                status: "failed"
            }), isIdleCallbackTrackingAddToCart);
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(e);
        }
    };
    const onBuy = ()=>{
        if (isCanAddToCard && primitiveProduct) {
            onAddItemToCart(primitiveProduct, selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId, price === null || price === void 0 ? void 0 : price.finalPrice);
        } else {
            var ref;
            (ref = showToast.info) === null || ref === void 0 ? void 0 : ref.call(showToast, {
                message: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("C\xf2n {{stockAvailable}} sản phẩm", {
                    stockAvailable: stockAvailable
                })
            });
        }
    };
    const onBuyNow = ()=>{
        if (primitiveProduct) {
            onAddItemToCart(primitiveProduct, selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId, price === null || price === void 0 ? void 0 : price.finalPrice, _teko_cart_v2__WEBPACK_IMPORTED_MODULE_9__/* .IsolatedCartType.BUY_NOW */ .oG.BUY_NOW);
        }
    };
    const onBuyInstallment = ()=>{
        if (primitiveProduct) {
            onAddItemToCart(primitiveProduct, selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId, price === null || price === void 0 ? void 0 : price.finalPrice, _teko_cart_v2__WEBPACK_IMPORTED_MODULE_9__/* .IsolatedCartType.INSTALLMENT */ .oG.INSTALLMENT);
        }
    };
    const handlePayOnInstallment = ()=>{
        if (selectedPromotionsNotApplyWithInstallment.length > 0) {
            return setShowWarningPromotionWithInstallment(true);
        }
        onBuyInstallment();
    };
    if (!product) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                contentName: showContact && contactLink ? "contactSale" : "addToCart",
                target: "productDetail",
                regionName: "bottomProductDetail",
                payload: JSON.stringify({
                    sku: product.sku,
                    screenName: "productDetail"
                })
            })), {
                isMobile: isMobile,
                marginTop: isMobile ? "s0" : "s12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductInfo, {
                        product: product,
                        payloadAddToCart: payloadAddToCart,
                        setPayloadAddToCart: setPayloadAddToCart
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__/* .Flex */ .k, {
                        align: "center",
                        justify: "space-between",
                        gap: "s8",
                        padding: isMobile ? [
                            "s8",
                            "s16",
                            "s0",
                            "s16"
                        ] : undefined,
                        borderTop: isMobile ? "1px solid border" : undefined,
                        children: showContact ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactButtonWrapper, _objectSpreadProps(_objectSpread({
                            width: "100%"
                        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .getTrackingData */ .O5)({
                            isTrackContent: true,
                            contentName: "contactSale",
                            target: "productDetail",
                            regionName: "bottomProductDetail",
                            payload: JSON.stringify({
                                sku: product.sku,
                                screenName: "productDetail"
                            })
                        })), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                width: "100%",
                                variant: "primary",
                                disabled: !contactLink && !actionReady,
                                className: !contactLink ? "out-of-stock-button" : "",
                                onClick: ()=>{
                                    if (contactLink) window.open(contactLink);
                                    return;
                                },
                                children: contactLink ? (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Li\xean hệ") : (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Hết h\xe0ng")
                            })
                        })) : !isAllowInstallmentPayment && !allowBuyNow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__/* .Shape */ .b, _objectSpreadProps(_objectSpread({
                            width: "100%"
                        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .getTrackingData */ .O5)({
                            isTrackContent: true,
                            contentName: "addToCart",
                            target: "productDetail",
                            regionName: "bottomProductDetail",
                            payload: JSON.stringify({
                                sku: product.sku,
                                screenName: "productDetail"
                            })
                        })), {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                width: "100%",
                                variant: "primary",
                                disabled: !actionReady,
                                onClick: ()=>onBuy(),
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Th\xeam v\xe0o giỏ h\xe0ng")
                            })
                        })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__/* .Flex */ .k, {
                            direction: "row",
                            width: "100%",
                            height: "100%",
                            align: "center",
                            justify: "space-between",
                            gap: "s12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__/* .Flex */ .k, {
                                    height: "48px",
                                    width: "48px",
                                    borderRadius: "s",
                                    border: "1px solid primary",
                                    align: "center",
                                    justify: "center",
                                    onClick: onBuy,
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_16__/* .ShoppingCartAddColored */ .k, {
                                        size: 18
                                    })
                                }),
                                allowBuyNow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__/* .Shape */ .b, {
                                    height: "100%",
                                    width: isAllowInstallmentPayment ? isMobile ? "calc((100% - 48px - 12px - 12px) / 2)" : "calc((100% - 48px - 12px - 12px) / 12 * 7)" : "calc(100% - 48px - 12px)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                        width: "100%",
                                        variant: "primary",
                                        disabled: !actionReady,
                                        onClick: ()=>onBuyNow(),
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Mua ngay")
                                    })
                                }),
                                isAllowInstallmentPayment && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__/* .Shape */ .b, {
                                    height: "100%",
                                    width: isAllowInstallmentPayment ? isMobile ? "calc((100% - 48px - 12px - 12px) / 2)" : "calc((100% - 48px - 12px - 12px) / 12 * 5)" : "calc(100% - 48px - 12px)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_17__/* .Button */ .z, {
                                        width: "100%",
                                        variant: "primary",
                                        disabled: !actionReady,
                                        onClick: ()=>handlePayOnInstallment(),
                                        backgroundColor: "#4CB9CC",
                                        height: "48px",
                                        padding: "s4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__/* .Flex */ .k, {
                                            direction: "column",
                                            align: "center",
                                            justify: "center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_18__/* .SubTitle */ .DK, {
                                                    color: "#F7FEFF",
                                                    level: 2,
                                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Trả g\xf3p")
                                                }),
                                                typeof minAmountByMonth === "number" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_18__/* .Caption */ .YS, {
                                                    color: "#F7FEFF",
                                                    level: 1,
                                                    children: "(".concat((0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Chỉ từ"), " ").concat((0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_19__/* .formatCurrency */ .xG)(minAmountByMonth, numberDisplayFormat), ")")
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_20__/* .Modal */ .u, {
                visible: showWarningPromotionWithInstallment,
                size: "s",
                cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Đ\xf3ng"),
                onCancel: ()=>setShowWarningPromotionWithInstallment(false),
                cancelButtonProps: {
                    style: {
                        width: "100%"
                    }
                },
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Tiến h\xe0nh trả g\xf3p"),
                onOk: ()=>{
                    setShowWarningPromotionWithInstallment(false);
                    onBuyInstallment();
                },
                okButtonProps: {
                    style: {
                        width: "100%"
                    }
                },
                showCloseIcon: false,
                alignFooter: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_21__/* .ModalHeader */ .x, {
                        padding: "s0",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Th\xf4ng b\xe1o")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_22__/* .ModalBody */ .f, {
                        paddingLeft: "s0",
                        paddingRight: "s0",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Sản phẩm c\xf3 khuyến mại kh\xf4ng được \xe1p dụng khi mua trả g\xf3p. Vui l\xf2ng chọn lại khuyến mại kh\xe1c hoặc tiến h\xe0nh trả g\xf3p m\xe0 kh\xf4ng \xe1p dụng khuyến mại")
                    })
                ]
            })
        ]
    });
};
const ProductInfo = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { product , payloadAddToCart , setPayloadAddToCart  } = props;
    const { colors  } = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_23__/* .useTheme */ .F)();
    const { uomCodeToDisplayDecimalQuantity , isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    const precision = (product === null || product === void 0 ? void 0 : product.uomCode) === uomCodeToDisplayDecimalQuantity ? 3 : 0;
    const selectedVariants = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.productOptions) === null || ref === void 0 ? void 0 : ref.rows.map((variant)=>variant.options.filter((option)=>option.selected).map((option)=>option.label)).join(", ");
    }, [
        product === null || product === void 0 ? void 0 : (ref = product.productOptions) === null || ref === void 0 ? void 0 : ref.rows
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__/* .Flex */ .k, {
        align: "center",
        justify: isMobile ? "space-between" : "start",
        padding: isMobile ? [
            "s8",
            "s16"
        ] : "s0",
        gap: isMobile ? "s8" : "s16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_24__/* .Row */ .X, {
                style: {
                    minWidth: 0
                },
                wrap: false,
                align: "middle",
                children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_25__/* .Col */ .JX, {
                            style: {
                                minWidth: 40
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                width: 40,
                                height: 40,
                                src: (product === null || product === void 0 ? void 0 : (ref1 = product.images) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.src) || "",
                                alt: (product === null || product === void 0 ? void 0 : (ref3 = product.images) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.alt) || "product-image-alt"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_25__/* .Col */ .JX, {
                            style: {
                                padding: "0 8px",
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EllipsisText, {
                                    style: {
                                        fontWeight: "bold",
                                        fontSize: "15px"
                                    },
                                    children: product === null || product === void 0 ? void 0 : product.displayName
                                }),
                                (product === null || product === void 0 ? void 0 : (ref5 = product.productGroup) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.variants) === null || ref6 === void 0 ? void 0 : ref6.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(EllipsisText, {
                                    style: {
                                        color: colors.textSecondary
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Ph\xe2n loại"),
                                                ": "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: selectedVariants
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_18__/* .Body */ .uT, {
                        level: 1,
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_12__.t)("Số lượng")
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuantityBlock, {
                quantity: (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) || 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_26__/* .Quantity */ .h, _objectSpreadProps(_objectSpread({
                    className: "quantity-selector",
                    disableMinus: (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) === 1,
                    quantity: (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) || 1,
                    setQuantity: (value)=>{
                        if (value !== (payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity)) {
                            setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                                return _objectSpreadProps(_objectSpread({}, prev), {
                                    quantity: value
                                });
                            });
                        }
                    },
                    onPlus: ()=>{
                        setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                            return _objectSpreadProps(_objectSpread({}, prev), {
                                quantity: (prev.quantity || 1) + 1
                            });
                        });
                    },
                    onMinus: ()=>{
                        if (((payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity) || 1) - 1 > 0) {
                            setPayloadAddToCart === null || setPayloadAddToCart === void 0 ? void 0 : setPayloadAddToCart((prev)=>{
                                return _objectSpreadProps(_objectSpread({}, prev), {
                                    quantity: (prev.quantity || 1) - 1
                                });
                            });
                        }
                    },
                    min: Math.pow(10, -precision)
                }, (0,helpers__WEBPACK_IMPORTED_MODULE_27__/* .getEnv */ .dU)("EPIC_ECOM_489") !== "enabled" ? {
                    decimalSeparator: "."
                } : {}), {
                    precision: precision,
                    blurOnEnter: true,
                    color: "textTitle"
                }))
            })
        ]
    });
};
const Wrapper = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_28__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__/* .Shape */ .b)((param)=>{
    let { isMobile  } = param;
    return "\n  padding-bottom: env(safe-area-inset-bottom);\n  min-height: 72px;\n  position: ".concat(isMobile ? "sticky" : "relative", ";\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n  z-index: 1030;\n  display: flex;\n  flex-direction: column;\n  gap: ").concat(isMobile ? "8px" : "12px", ";\n  padding-bottom: ").concat(isMobile ? "24px" : "0px", ";\n  border-top: ").concat(isMobile ? "1px solid #ddd" : "", ";\n");
});
const ContactButtonWrapper = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_28__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__/* .Shape */ .b)(_templateObject());
const StyledButton = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_28__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_17__/* .Button */ .z)(_templateObject1());
const EllipsisText = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_28__["default"].div(_templateObject2());
const QuantityBlock = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_28__["default"].div(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.border;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.border;
}, (param)=>{
    let { quantity  } = param;
    return quantity > 1 && "\n    .minus-btn {\n      background-color: white;\n    }\n  ";
});


/***/ }),

/***/ 846268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NewPolicies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(425336);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(316035);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(634655);
/* harmony import */ var modules_product_detail_shared_ProductProviderInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(768439);
/* harmony import */ var _PolicyAndService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(761453);







const NewPolicies = ()=>{
    const { salePolicies , otherPolicies  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useProductDetailState */ .W)();
    const { isMobile  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (salePolicies === null || salePolicies === void 0 ? void 0 : salePolicies.length) || (otherPolicies === null || otherPolicies === void 0 ? void 0 : otherPolicies.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Shape */ .b, {
            backgroundColor: "white",
            borderRadius: "m",
            className: "BOXCARDBODY-RIGHT",
            marginTop: isMobile ? "s8" : "s12",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_product_detail_shared_ProductProviderInfo__WEBPACK_IMPORTED_MODULE_4__/* .ProductProviderInfo */ .S, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Shape */ .b, {
                    padding: isMobile ? "s16" : "s8",
                    children: [
                        !!(salePolicies === null || salePolicies === void 0 ? void 0 : salePolicies.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PolicyAndService__WEBPACK_IMPORTED_MODULE_5__/* .PolicyAndService */ .q, {
                            title: (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Ch\xednh s\xe1ch b\xe1n h\xe0ng"),
                            information: salePolicies,
                            max: 4,
                            columns: isMobile ? 1 : 2
                        }),
                        !!(otherPolicies === null || otherPolicies === void 0 ? void 0 : otherPolicies.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PolicyAndService__WEBPACK_IMPORTED_MODULE_5__/* .PolicyAndService */ .q, {
                            title: (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Dịch vụ kh\xe1c"),
                            information: otherPolicies,
                            max: 4,
                            columns: isMobile ? 1 : 2,
                            marginTop: "s12"
                        })
                    ]
                })
            ]
        }) : null
    });
};


/***/ }),

/***/ 534631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ProductInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(825078);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(212951);
/* harmony import */ var components_WishlistButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(288257);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(723357);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(316035);
/* harmony import */ var helpers_page_actions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(347822);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(634655);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  ",
        "\n  margin: 0;\n  text-align: left;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  ::before {\n    content: '|';\n    margin: 0 24px;\n    color: #0000000f;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









const shortenString = function(name) {
    let maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    var ref;
    const trimmedName = name === null || name === void 0 ? void 0 : name.trim();
    if (!trimmedName) return "";
    if (trimmedName.length <= maxLength) return trimmedName;
    return "".concat((ref = trimmedName.slice(0, maxLength)) === null || ref === void 0 ? void 0 : ref.trimEnd(), "...");
};
const ProductBrand = (param)=>{
    let { brandCode , brandName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: {
            pathname: "/brands/[brandId]",
            query: {
                brandId: brandCode
            }
        },
        as: {
            pathname: "/".concat(brandCode, "-brand.").concat(brandCode)
        },
        shallow: true,
        passHref: true,
        legacyBehavior: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandNameTextLink, {
            children: shortenString(brandName)
        })
    });
};
const ProductInfo = ()=>{
    var ref, ref1, ref2;
    const { epicOmni1550 , isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureFlags */ .g)();
    const { productRatingData , product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useProductDetailState */ .W)();
    const { totalReviews , averageRating  } = productRatingData;
    if (!product) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
        direction: "column",
        gap: "s4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                        level: 1,
                        color: "textPrimary",
                        children: [
                            (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Thương hiệu"),
                            ":"
                        ]
                    }),
                    flags.epic_omni_1552 && (product === null || product === void 0 ? void 0 : (ref = product.brands) === null || ref === void 0 ? void 0 : ref.length) > 0 ? product.brands.map((brand, index)=>{
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBrand, {
                                    brandCode: brand.code,
                                    brandName: brand.name
                                }, "".concat(brand.code).concat(brand.name).concat(index)),
                                index + 1 !== (product === null || product === void 0 ? void 0 : (ref = product.brands) === null || ref === void 0 ? void 0 : ref.length) && ",\xa0"
                            ]
                        }, index);
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBrand, {
                        brandCode: product === null || product === void 0 ? void 0 : (ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.code,
                        brandName: product === null || product === void 0 ? void 0 : (ref2 = product.brand) === null || ref2 === void 0 ? void 0 : ref2.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                align: "top",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                        flex: isMobile ? "75%" : "100%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductName, {
                            isMobile: isMobile,
                            level: 1,
                            color: "textTitle",
                            weight: "bold",
                            children: product.displayName || product.name
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                        flex: "25%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                            align: "center",
                            justify: "end",
                            gap: "s4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                                    level: 1,
                                    color: "textTitle",
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Y\xeau th\xedch")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WishlistButton__WEBPACK_IMPORTED_MODULE_11__/* .WishlistButton */ .s, {
                                    sku: product.sku,
                                    size: "24"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                        level: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                            level: 1,
                            color: "textPrimary",
                            children: [
                                (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("SKU"),
                                ": ",
                                product.sellerSku || product.sku
                            ]
                        })
                    }),
                    epicOmni1550 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .RatingFilled */ .A, {
                                size: 20,
                                color: "support"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                                level: 2,
                                margin: [
                                    "s0",
                                    "s4"
                                ],
                                children: averageRating !== null && averageRating !== void 0 ? averageRating : 0
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                                level: 1,
                                color: "primary500",
                                onClick: ()=>(0,helpers_page_actions__WEBPACK_IMPORTED_MODULE_13__/* .scrollSmoothToIdWithOffset */ .A)("review-section", isMobile ? 60 : 90),
                                style: {
                                    cursor: "pointer"
                                },
                                children: "(".concat(totalReviews !== null && totalReviews !== void 0 ? totalReviews : 0, " ").concat((0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("đ\xe1nh gi\xe1"), ")")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const ProductName = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6)(_templateObject(), (param)=>{
    let { isMobile  } = param;
    return isMobile ? "\n    font-size: 20px;\n    line-height: 28px;\n    " : "\n    font-size: 24px;\n    line-height: 32px;\n    ";
});
const BrandNameTextLink = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__["default"].a((param)=>{
    let { theme  } = param;
    var ref;
    return "\n  color: ".concat(theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary, ";\n  font-weight: normal;\n  margin-left: 4px;\n  font-size: 13px;\n  line-height: 20px;\n  text-decoration: none;\n");
});
const Divider = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_14__["default"].div(_templateObject1());


/***/ }),

/***/ 23704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(329944);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54230);
/* harmony import */ var _teko_types_dist_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(414951);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(316035);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(634655);
/* harmony import */ var modules_product_detail_hooks_useGetPriceDetailPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(906825);
/* harmony import */ var modules_product_detail_shared_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(324041);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 32px;\n  line-height: 40px;\n  text-align: right;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const ProductPrice = ()=>{
    const { numberDisplayFormat , isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { calculatePrice  } = (0,modules_product_detail_hooks_useGetPriceDetailPage__WEBPACK_IMPORTED_MODULE_3__/* .useGetPriceDetailPage */ .P)();
    const { price , minAmountByMonth  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useProductDetailState */ .W)();
    const supplierRetailPrice = (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .xG)(calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.supplierRetailPrice, numberDisplayFormat) || "";
    const latestPrice = (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .xG)(price === null || price === void 0 ? void 0 : price.finalPrice, numberDisplayFormat) || "";
    const discountPercent = price === null || price === void 0 ? void 0 : price.discountPercent;
    const showRetailPrice = supplierRetailPrice && (0,modules_product_detail_shared_helpers__WEBPACK_IMPORTED_MODULE_6__/* .isShowRetailPrice */ .D)(calculatePrice === null || calculatePrice === void 0 ? void 0 : calculatePrice.supplierRetailPrice, price === null || price === void 0 ? void 0 : price.finalPrice);
    const isShowDiscount = !!discountPercent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
        direction: "column",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Divider */ .i, {
                dividerStyle: _teko_types_dist_shared__WEBPACK_IMPORTED_MODULE_1__/* .DividerStyleEnum.dashed */ .fd.dashed,
                color: "divider",
                gap: 8,
                margin: [
                    isMobile ? "s8" : "s12",
                    "s0"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
                direction: "column",
                align: "start",
                children: [
                    (showRetailPrice || isShowDiscount) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
                        direction: "row",
                        gap: "s8",
                        height: "1rem",
                        children: [
                            showRetailPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                                level: 1,
                                decoration: "line-through",
                                color: "textSecondary",
                                children: supplierRetailPrice
                            }),
                            isShowDiscount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                                level: 1,
                                color: "#F5222D",
                                children: discountPercent
                            })
                        ]
                    }),
                    isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Title */ .Dx, {
                        level: 1,
                        color: "primary500",
                        children: latestPrice
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLatestPrice, {
                        color: "primary500",
                        children: latestPrice
                    })
                ]
            }),
            typeof minAmountByMonth === "number" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
                direction: "column",
                backgroundColor: "secondary100",
                height: 60,
                width: "100%",
                borderLeft: "2px solid #4CB9CC",
                padding: "s8",
                marginTop: "s4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                        level: 2,
                        color: "textTitle",
                        textTransform: "uppercase",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Mua trả g\xf3p")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .SubTitle */ .DK, {
                        level: 2,
                        color: "secondary700",
                        children: [
                            (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrency */ .xG)(minAmountByMonth, numberDisplayFormat),
                            "/",
                            (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("th\xe1ng")
                        ]
                    })
                ]
            })
        ]
    });
};
// Use styled instead of H4 for SEO
const StyledLatestPrice = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Title */ .Dx)(_templateObject());


/***/ }),

/***/ 903657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ ProductPromotions; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../packages/cart/dist/v2/index.js
var v2 = __webpack_require__(511335);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 5 modules
var ProductDetailContext = __webpack_require__(316035);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./modules/product-detail/shared/DefaultPromotions.tsx + 1 modules
var DefaultPromotions = __webpack_require__(693442);
// EXTERNAL MODULE: ./modules/product-detail/shared/TierPromotion.tsx + 1 modules
var TierPromotion = __webpack_require__(795021);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ChevronUpOutlined.es.js
var ChevronUpOutlined_es = __webpack_require__(635384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ChevronDownOutlined.es.js
var ChevronDownOutlined_es = __webpack_require__(115959);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/GiftFilled.es.js
var GiftFilled_es = __webpack_require__(356026);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CheckOutlined.es.js
var CheckOutlined_es = __webpack_require__(4247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(446586);
// EXTERNAL MODULE: ../../packages/types/dist/shared/index.js
var shared = __webpack_require__(414951);
// EXTERNAL MODULE: ../../packages/utils/dist/polyfill.es.js
var polyfill_es = __webpack_require__(593859);
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-2.3.6-0bc101c0e7-4b2bbf6bc6.zip/node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(391547);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
;// CONCATENATED MODULE: ./modules/product-detail/shared/NewLayoutComponents/SelectionPromotions.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background: linear-gradient(\n    180deg,\n    #f5f5f5 0%,\n    rgba(245, 245, 245, 0.6) 100%\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  padding: 6px 0px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  white-space: pre-line;\n  img {\n    height: 20px;\n    width: 20px;\n    border-radius: 4px;\n    border: 1px solid #0000000f;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










const SelectionPromotions = (props)=>{
    const { title , description , promotions =[] , isExclusivePromotionGroups =false ,  } = props;
    const MAX_ITEMS_PROMOTIONS = isExclusivePromotionGroups ? 1 : 3;
    const { product , setSelectedPromotion  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { 0: showFullPromotions , 1: setShowFullPromotions  } = (0,react.useState)(false);
    const handlePromotionClick = (promotion, index)=>{
        if (!promotion) return;
        if (promotion.isSelected) {
            setSelectedPromotion === null || setSelectedPromotion === void 0 ? void 0 : setSelectedPromotion(undefined);
        } else {
            setSelectedPromotion === null || setSelectedPromotion === void 0 ? void 0 : setSelectedPromotion(promotion);
        }
        (0,polyfill_es/* requestIdleCallback */.Kk)(()=>{
            return (0,cart_es/* trackManually */.gu)(promotion.name, "optionalPromotion", "productDetail", JSON.stringify({
                sku: product === null || product === void 0 ? void 0 : product.sku,
                action: promotion.isSelected ? "unselect" : "select",
                promotionID: promotion.promotionId,
                screenName: "productDetail",
                index
            }));
        });
    };
    const toggleShowFullPromotions = ()=>{
        setShowFullPromotions((prev)=>!prev);
    };
    if ((promotions === null || promotions === void 0 ? void 0 : promotions.length) === 0) return null;
    const convertPromotion = showFullPromotions ? promotions : promotions.slice(0, MAX_ITEMS_PROMOTIONS);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        direction: "column",
        gap: "s8",
        borderRadius: "s",
        padding: "s8",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Caption */.YS, {
                level: 2,
                color: "#000000A6",
                children: [
                    (0,i18n.t)(title),
                    ":",
                    "".concat(description ? " (".concat(description, ")") : "")
                ]
            }),
            convertPromotion === null || convertPromotion === void 0 ? void 0 : convertPromotion.map((promotion, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionOption, {
                    promotion: promotion,
                    onClick: ()=>handlePromotionClick(promotion, index),
                    isExclusive: !!isExclusivePromotionGroups
                }, promotion.promotionId || index)),
            promotions.length > MAX_ITEMS_PROMOTIONS && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                align: "middle",
                justify: "center",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SeeMoreView, {
                    direction: "row",
                    onClick: toggleShowFullPromotions,
                    gap: "s8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            level: 1,
                            color: "textTitle",
                            children: showFullPromotions ? (0,i18n.t)("Ẩn bớt") : (0,i18n.t)("Xem th\xeam {{numOfPromotion}} KM kh\xe1c", {
                                numOfPromotion: promotions.length - MAX_ITEMS_PROMOTIONS
                            })
                        }),
                        showFullPromotions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpOutlined_es/* ChevronUpOutlined */.G, {
                            color: "textTitle",
                            size: 9
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownOutlined_es/* ChevronDownOutlined */.B, {
                            color: "textTitle",
                            size: 9
                        })
                    ]
                })
            })
        ]
    });
};
const Wrapper = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject());
const SeeMoreView = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject1());
const PromotionOption = (param)=>{
    let { promotion , onClick , isExclusive  } = param;
    var ref, ref1;
    const { isSelectable , isSelected  } = promotion;
    var _endedAt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shape_index_es/* Shape */.b, {
        backgroundColor: "background",
        borderRadius: "m",
        borderStyle: "solid",
        borderWeight: "l",
        borderColor: isSelected ? "primary500" : "border",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PromotionOptionWrapper, {
                onClick: isSelectable ? onClick : undefined,
                disable: !isSelectable,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        align: "center",
                        justify: "start",
                        padding: [
                            "s8",
                            "s12",
                            "s4"
                        ],
                        gap: "s8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftFilled_es/* GiftFilled */.p, {
                                color: !!isExclusive ? "primary500" : "#4CB9CC",
                                size: 16
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionOptionLabel, {
                                level: 1,
                                color: "textTitle",
                                width: "100%",
                                dangerouslySetInnerHTML: {
                                    __html: ((purify_default()) === null || (purify_default()) === void 0 ? void 0 : (ref = (purify_default()).sanitize) === null || ref === void 0 ? void 0 : ref.call((purify_default()), promotion.title)) || promotion.title
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                        dividerStyle: shared/* DividerStyleEnum.dashed */.fd.dashed,
                        color: "#0000000F",
                        gap: "0",
                        border: "1px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        justify: "space-between",
                        width: "100%",
                        align: "end",
                        padding: [
                            "s4",
                            "s12",
                            "s8"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                direction: "column",
                                gap: "s4",
                                children: [
                                    !!((ref1 = promotion.highlightedDescriptions) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                        level: 1,
                                        weight: "regular",
                                        color: "pending700",
                                        children: promotion.highlightedDescriptions[0]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionText, {
                                        level: 1,
                                        color: "textPrimary",
                                        children: promotion.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredAt, {
                                        level: 1,
                                        color: "textPrimary",
                                        children: "".concat((0,i18n.t)("HSD"), ": ").concat(new Date((_endedAt = promotion.endedAt) !== null && _endedAt !== void 0 ? _endedAt : new Date()).toLocaleDateString("vi"))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                direction: "column",
                                width: "min-content",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTick, {
                                    isSelected: !!isSelected,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckOutlined_es/* CheckOutlined */.b, {
                                        color: "white",
                                        size: 16
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !isSelectable && !isExclusive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                justify: "start",
                padding: [
                    "s4",
                    "s12"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                    level: 1,
                    children: (0,i18n.t)("Kh\xf4ng \xe1p dụng c\xf9ng Ưu đ\xe3i đặc biệt")
                })
            })
        ]
    });
};
const maxLineCss = (maxLines)=>"\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: ".concat(maxLines, ";\n");
const PromotionOptionWrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { disable  } = param;
    return "\n  background-color: white;\n  width: 100%;\n  border-radius: 8px;\n  ".concat(disable && "border: 1.5px solid #0000000F", ";\n  cursor: pointer;\n  ").concat(disable && "opacity: 0.4; cursor: not-allowed;", "\n");
});
const PromotionOptionLabel = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject2());
const ConditionText = (0,emotion_styled_browser_esm["default"])(index_es/* Caption */.YS)(_templateObject3(), maxLineCss(2));
const ExpiredAt = (0,emotion_styled_browser_esm["default"])(index_es/* Caption */.YS)(_templateObject4());
const StyledTick = emotion_styled_browser_esm["default"].div((param)=>{
    let { isSelected , theme  } = param;
    return "\n    width: 24px;\n    height: 24px;\n    border-radius: 999px;\n    background-color: ".concat(isSelected ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "white", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid ").concat(isSelected ? theme === null || theme === void 0 ? void 0 : theme.colors.primary : "#00000026", ";\n\n");
});

;// CONCATENATED MODULE: ./modules/product-detail/shared/NewLayoutComponents/ProductPromotions.tsx








const MAX_LINES_BEFORE_ELLIPSIS = 2;
const isPromotionDefaultGroupType = (promotions, groupType)=>{
    return groupType ? groupType === v2/* PromotionGroupType.GROUP_TYPE_DEFAULT */.VM.GROUP_TYPE_DEFAULT : promotions.every((p)=>!p.isSelectable);
};
const mapTierPromotions = (promotions)=>{
    return promotions.map((promotion)=>{
        var ref;
        return {
            cartPromotionId: null,
            promotionId: promotion.promotionId,
            promotionCode: promotion.promotionCode,
            isSelectable: promotion.isSelectable,
            imageUrl: promotion.imageUrl,
            title: promotion.title,
            description: promotion.description,
            endedAt: ((ref = promotion.endedAt) === null || ref === void 0 ? void 0 : ref.toString()) || "",
            name: promotion.name || "",
            tierDescriptions: promotion.tierDescriptions,
            highlightedDescriptions: promotion.highlightedDescriptions,
            customerTierDescriptions: promotion.customerTierDescriptions
        };
    });
};
const buildTierPromotionProps = (promotions)=>[
        {
            title: "",
            groupType: undefined,
            promotions: mapTierPromotions(promotions)
        }, 
    ];
const hasVisibleDefaultPromotions = (promotions)=>promotions.some((promotion)=>!!promotion.title);
const buildNewPromotionBlocks = (promotionBlocks)=>{
    if (!promotionBlocks.length) return [];
    const tierPromotionBlock = {
        title: "",
        groupType: v2/* PromotionGroupType.GROUP_TYPE_TIER_PROMOTIONS */.VM.GROUP_TYPE_TIER_PROMOTIONS,
        promotions: promotionBlocks.flatMap((p)=>p.promotions),
        description: ""
    };
    return [
        ...promotionBlocks,
        tierPromotionBlock
    ];
};
const ProductPromotions = ()=>{
    const { promotionBlocks  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { epicOmni1428 , epicOmni1585  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const showTierPromotionsBlock = !!epicOmni1428 || !!epicOmni1585;
    const blocks = (0,react.useMemo)(()=>showTierPromotionsBlock ? buildNewPromotionBlocks(promotionBlocks) : promotionBlocks, [
        promotionBlocks,
        showTierPromotionsBlock
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
        direction: "column",
        gap: "s8",
        justify: "center",
        children: blocks.map((block, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MemoPromotionBlock, {
                block: block,
                index: index,
                showCustomerTierPromotions: epicOmni1585,
                showTierPromotions: epicOmni1428
            }, index))
    });
};
const PromotionBlock = (param)=>{
    let { block , index , showCustomerTierPromotions , showTierPromotions  } = param;
    const isDefaultGroup = isPromotionDefaultGroupType(block.promotions, block.groupType);
    // Default Promotions
    if (isDefaultGroup) {
        if (!hasVisibleDefaultPromotions(block.promotions)) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultPromotions/* DefaultPromotions */.G, {
            promotions: block.promotions
        }, index);
    }
    // Exclusive Promotions
    if (block.groupType === v2/* PromotionGroupType.GROUP_TYPE_EXCLUSIVE */.VM.GROUP_TYPE_EXCLUSIVE) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectionPromotions, {
            title: block.title,
            description: block.description,
            promotions: block.promotions,
            isExclusivePromotionGroups: true
        }, index);
    }
    // Tier promotions
    if (block.groupType === v2/* PromotionGroupType.GROUP_TYPE_TIER_PROMOTIONS */.VM.GROUP_TYPE_TIER_PROMOTIONS) {
        const tierProps = buildTierPromotionProps(block.promotions);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                showCustomerTierPromotions && /*#__PURE__*/ (0,jsx_runtime.jsx)(TierPromotion/* TierPromotions */.X, {
                    productPromotions: tierProps,
                    isCustomerTierPromotions: true
                }),
                showTierPromotions && /*#__PURE__*/ (0,jsx_runtime.jsx)(TierPromotion/* TierPromotions */.X, {
                    productPromotions: tierProps,
                    maxLinesBeforeEllipsis: MAX_LINES_BEFORE_ELLIPSIS
                })
            ]
        }, index);
    }
    // Selectable Promotions
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectionPromotions, {
        title: block.title,
        description: block.description,
        promotions: block.promotions
    }, index);
};
const MemoPromotionBlock = /*#__PURE__*/ react.memo(PromotionBlock, (prev, next)=>prev.block === next.block && prev.index === next.index);


/***/ }),

/***/ 609586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MAX_ITEMS_WITH_TWO_BLOCKS; },
/* harmony export */   "x": function() { return /* binding */ RelatedBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(319326);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(212951);
/* harmony import */ var components_YoutubeFrame__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(742609);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  line-height: 22px;\n  color: #1b1d29;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 540px;\n  background-color: black;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  line-height: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





const MAX_ITEMS_WITH_TWO_BLOCKS = 3;
const RelatedBlock = (props)=>{
    const { title , seeMoreUrl , items , type  } = props;
    const { 0: youtubeLink , 1: setYoutubeLink  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const renderItem = (url, description)=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .k, {
            align: "center",
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
                    height: "68px",
                    width: "120px",
                    borderRadius: 4,
                    contain: true,
                    src: url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                    width: "calc(100% - 120px - 16px)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
                        level: 1,
                        line: 3,
                        children: description
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .Card */ .Z, {
        padding: "s16",
        id: "related-".concat(type),
        width: "100%",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .k, {
                direction: "row",
                justify: "space-between",
                paddingBottom: "s16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledH3, {
                        children: title
                    }),
                    seeMoreUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .CustomLink */ .x, {
                        href: seeMoreUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                            variant: "link",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSeeMore, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Xem th\xeam")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .k, {
                direction: "column",
                gap: "s16",
                children: items.map((item, index)=>{
                    const { url , thumbnailUrl , description  } = item;
                    return type === "post" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCustomLink, {
                        href: url,
                        target: "_blank",
                        children: renderItem(thumbnailUrl, description)
                    }, "".concat(index).concat(url)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .Shape */ .b, {
                        onClick: ()=>setYoutubeLink(url),
                        style: {
                            cursor: "pointer",
                            width: "100%"
                        },
                        children: renderItem(thumbnailUrl, description)
                    }, "".concat(index).concat(url));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__/* .Modal */ .u, {
                visible: !!youtubeLink,
                width: "960px",
                onClose: ()=>setYoutubeLink(""),
                showCloseIcon: false,
                footer: false,
                contentStyle: {
                    padding: "0px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IFramePopupWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_YoutubeFrame__WEBPACK_IMPORTED_MODULE_11__.YoutubeFrame, {
                        youtubeLink: youtubeLink
                    })
                })
            })
        ]
    });
};
const StyledSeeMore = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__["default"].p(_templateObject());
const StyledCustomLink = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_7__/* .CustomLink */ .x)(_templateObject1());
const IFramePopupWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__["default"].div(_templateObject2());
const StyledH3 = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__["default"].h3(_templateObject3());


/***/ }),

/***/ 786709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RelatedPosts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(316035);
/* harmony import */ var _RelatedBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(609586);



const RelatedPosts = ()=>{
    var ref, ref1;
    const { product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useProductDetailState */ .W)();
    const { relatedPosts  } = (product === null || product === void 0 ? void 0 : product.seoInfo) || {};
    if (!(relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref = relatedPosts.urls) === null || ref === void 0 ? void 0 : ref.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RelatedBlock__WEBPACK_IMPORTED_MODULE_2__/* .RelatedBlock */ .x, {
        title: (relatedPosts === null || relatedPosts === void 0 ? void 0 : relatedPosts.title) || "",
        seeMoreUrl: relatedPosts === null || relatedPosts === void 0 ? void 0 : relatedPosts.seeMoreUrl,
        type: "post",
        items: (relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref1 = relatedPosts.urls) === null || ref1 === void 0 ? void 0 : ref1.slice(0, _RelatedBlock__WEBPACK_IMPORTED_MODULE_2__/* .MAX_ITEMS_WITH_TWO_BLOCKS */ .R).map((param)=>{
            let { url , thumbnailUrl , description  } = param;
            return {
                url: url || "",
                thumbnailUrl: thumbnailUrl || "",
                description: description || ""
            };
        })) || []
    });
};


/***/ }),

/***/ 722206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RelatedVideos; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(316035);
/* harmony import */ var _RelatedBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(609586);



const RelatedVideos = ()=>{
    var ref, ref1;
    const { product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useProductDetailState */ .W)();
    const { relatedVideos  } = (product === null || product === void 0 ? void 0 : product.seoInfo) || {};
    if (!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref = relatedVideos.urls) === null || ref === void 0 ? void 0 : ref.length)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RelatedBlock__WEBPACK_IMPORTED_MODULE_2__/* .RelatedBlock */ .x, {
        title: (relatedVideos === null || relatedVideos === void 0 ? void 0 : relatedVideos.title) || "",
        seeMoreUrl: relatedVideos === null || relatedVideos === void 0 ? void 0 : relatedVideos.seeMoreUrl,
        type: "video",
        items: (relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref1 = relatedVideos.urls) === null || ref1 === void 0 ? void 0 : ref1.slice(0, _RelatedBlock__WEBPACK_IMPORTED_MODULE_2__/* .MAX_ITEMS_WITH_TWO_BLOCKS */ .R).map((param)=>{
            let { url , thumbnailUrl , description  } = param;
            return {
                url: url || "",
                thumbnailUrl: thumbnailUrl || "",
                description: description || ""
            };
        })) || []
    });
};


/***/ })

}]);